module.exports = __webpack_public_path__ + "img/kf.9cb89f08.png";